// v-calendar's `is-dark` setting: the calendar watches the class list on <html> and switches
// to its dark palette while the admin dark theme class (set by useTheme) is present.
export const CALENDAR_DARK_MODE = {
	selector: 'html',
	darkClass: 'admin-theme-dark',
};
